import { Controller } from '@hotwired/stimulus'
import delay from 'lodash/delay'

export default class extends Controller {
  static targets = ['main', 'floatingButton', 'floatingButtonTrigger', 'leaveModal']

  get className () {
    return this.element.dataset.classname
  }

  static classes = [
    'displayVisible',
    'displayHidden',
    'visibilityVisible',
  ]

  connect () {
    history.replaceState(null, null, location.href)
    history.pushState(null, null, location.href)

    this.showChat()

    window.addEventListener('beforeunload', this.openUnloadDialog)
    this.leaveModalEvent = this.openLeaveModal.bind(this)
    document.body.addEventListener('mouseleave', this.leaveModalEvent)

    this.popStateHandler = this.handlePopState.bind(this)
    window.addEventListener('popstate', this.popStateHandler)
  }

  disconnect () {
    window.removeEventListener('popstate', this.popStateHandler)
  }

  initialize () {
    let lastScrollPosition = 0
    let ticking = false

    window.addEventListener('scroll', () => {
      lastScrollPosition = window.scrollY
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.toggleVisibility(lastScrollPosition)
          ticking = false
        })
        ticking = true
      }
    })
  }

  showChat () {
    const chatQuestionContainer = document.getElementById('chat_question_container_step1')
    const loaders = chatQuestionContainer.getElementsByClassName(`${this.className}::loader`)
    const chatQuestions = chatQuestionContainer.getElementsByClassName(`${this.className}::chat-question`)

    Array.from(chatQuestions).forEach((elm, index) => {
      delay(() => {
        chatQuestionContainer.classList.add(this.visibilityVisibleClass)
      }, 800)
      delay(() => {
        loaders[index].classList.add(this.displayHiddenClass)
      }, 800 * (index + 2) - 400)
      delay(() => {
        chatQuestions[index].classList.add(this.displayVisibleClass)
      }, 800 * (index + 2))
      delay(() => {
        this.mainTargets[0].classList.add(this.displayVisibleClass)
      }, 800 * (index + 4))
    })
  }

  toggleVisibility (scrollPosition) {
    if (!this.hasFloatingButtonTriggerTarget && !this.hasFloatingButtonTarget) return
    const triggerPosition = this.floatingButtonTriggerTargets[0].getBoundingClientRect().top
    if (scrollPosition > triggerPosition) {
      this.floatingButtonTarget.classList.add(this.visibilityVisibleClass)
    } else {
      this.floatingButtonTarget.classList.remove(this.visibilityVisibleClass)
    }
  }

  handleClick () {
    if (this.clicked) return
    this.clicked = true
    console.log('image touched')
  }

  handleTouch (event) {
    if (this.touched) return
    this.touched = true
    event.preventDefault()
    this.handleClick()
  }

  handlePopState () {
    this.openLeaveModal()

    history.pushState(null, null, location.href)
  }

  openLeaveModal () {
    this.closeLeaveModal()
    this.leaveModalTarget.classList.remove(this.displayHiddenClass)
  }

  closeLeaveModal () {
    this.leaveModalTarget.classList.add(this.displayHiddenClass)
  }
}
